import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";;
import { SnackBarService } from '../../service/snack.bar.service';
import { GetELaunchByIdGQL, GetLeadByContactIdGQL, GetUserDetailsGQL } from '../../../../generated/graphql';
import * as moment from "moment";
import { DateFormatPipe } from "../../pipe/date-format.pipe";


export interface DialogData {
  eLaunchId: string;
}

@Component({
  selector: 'elaunch-view-dialog',
  templateUrl: 'elaunch-view-dialog.html',
})
export class ElaunchViewDialog implements OnInit {
  title: string = "E-Launch Details";
  result: any;
  isCompany: boolean = false;
  eLaunchData: any;
  minEndDate: Date;
  maxPublishDate: Date;
  maxEndDate: Date;
  minTerminationDate: Date;
  minStartDate: Date;

  constructor(
    public dialogRef: MatDialogRef<ElaunchViewDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private getELaunchByIdGQL: GetELaunchByIdGQL,
    private snackBarSvc: SnackBarService,) {
  }

  ngOnInit() {
    this.getData();
  }

  public getData(){
    this.getELaunchByIdGQL.fetch({ eLaunchId: this.data.eLaunchId })
    .subscribe(result =>{
      if(result.errors){
        this.snackBarSvc.showQueryError(result.errors);
      }
      this.eLaunchData = result.data.getELaunchById;

        this.eLaunchData.startDate = moment(this.eLaunchData?.startDate).toDate();
        this.eLaunchData.terminationDate = moment(this.eLaunchData?.terminationDate).toDate();
        this.eLaunchData.endDate = moment(this.eLaunchData?.endDate).toDate();
        this.eLaunchData.publishDate = moment(this.eLaunchData?.publishDate).toDate();
      
    })
  }


}